import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertService } from '@app/shared/alert/alert.service';
import Utils from '@app/shared/utils';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompletedSealDistributionService } from './completed-seal-distribution.service';

@Component({
  selector: 'app-completed',
  templateUrl: './completed.component.html',
  styleUrls: ['./completed.component.scss']
})
export class CompletedComponent implements OnInit {
  form: FormGroup;
  sealCompleted$ : Observable<any>;
  sealCompletedPage$ : Observable<any>;
  columns = [{ name: 'Date Requested' , prop: 'dateCreated'},
              { name: 'Reference ID' , prop: 'referenceID'},
              { name: 'Facility Name' } , { name: 'Quantity' },
              { name: 'Date Processed' },
              { name: 'Date Shipped' },
              { name: 'Date Received' },
              { name: 'Assigned Seals' , prop: 'sealsData'}
            ];
  
  constructor(private formBuilder: FormBuilder,private completedSealDistributionService: CompletedSealDistributionService, private alertService: AlertService ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      quantity: [''],
      referenceID: [''],
      requestStatus: ['']
    });
    this.completedSealDistributionService.getAll(0).subscribe();
    this.sealCompleted$ =  this.completedSealDistributionService.recordsObservable.pipe(
      map(x => {
        if(x){
          x["results"].forEach(element => {
            element["dataModel"]["facilityName"] = element["dataModel"]["facility"]["facilityName"];
            element["dataModel"]["dateCreated"] = element["dateCreated"];
            element["dataModel"]["dateUpdated"] = element["dateUpdated"];
            element["dataModel"]["sealsData"] = []
            element["dataModel"]["seals"]["results"].forEach(element2 => {
              element["dataModel"]["sealsData"].push(Utils.mapModelToColumns(element2))
            });
            var groupedData = [];
            for (let [key, value] of Object.entries(Utils.groupBy(element["dataModel"]["sealsData"], "groupId"))) {
              if((value as []).length > 1)
                groupedData.push({"id": key, "serialNumber": (value[0]["batchCode"] ? value[0]["batchCode"] : "")+Math.min.apply(null, (value as []).map(e => e["serialNumber"]))+"-"+(value[0]["batchCode"] ? value[0]["batchCode"] : "")+Math.max.apply(null, (value as []).map(e => e["serialNumber"]))});
              else 
                groupedData.push({"id": key, "serialNumber": (value[0]["batchCode"] ? value[0]["batchCode"] : "")+value[0]["serialNumber"]});
            }
            element["dataModel"]["sealsData"] = groupedData;
            
            element["dataModel"]["sealsData"] = element["dataModel"]["sealsData"].map(x => x.serialNumber);
            element["dataModel"]["referenceID"] = element["dataModel"]["referenceID"].substring(24,36).toUpperCase( );
          });
          return x["results"].map(x => Utils.mapModelToForm(x,['dateCreated','dateProcessed','dateReceived','dateShipped']));
        }
        return of(null);
      })
    )
    this.sealCompletedPage$ = this.completedSealDistributionService.recordsObservable;
  }

  getPage(page: string) {
    this.completedSealDistributionService.getAll(page).subscribe();
  }

  search(keyword: string) {
    if(keyword != '')
        this.completedSealDistributionService.searchAndRefresh(keyword).subscribe();
    else
        this.completedSealDistributionService.getAll(0).subscribe();
  }
}
